module.exports = __webpack_public_path__ + "img/icon-car.46e4ff74.svg";